import { render } from "./GenreList.vue?vue&type=template&id=42b32af2&scoped=true"
import script from "./GenreList.vue?vue&type=script&lang=js"
export * from "./GenreList.vue?vue&type=script&lang=js"

import "./GenreList.vue?vue&type=style&index=0&id=42b32af2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42b32af2"

export default script